import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {Axios} from '@/assets/api/axios'
import {GetCookie,DelCookie} from '@/assets/api/cookie'
import notifyIcon from '@/assets/img/msgicon.png'
import 'lib-flexible/flexible'
import './plugins/rem'
import { Swipe, SwipeItem, Lazyload, Icon, Tab, Tabs, Field, Checkbox, Button, Overlay, SwipeCell, Uploader, DatetimePicker, Popup, Area, ActionSheet, Loading, List, Cell, Skeleton} from 'vant'
import 'vant/lib/index.css'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
const options = {
	background:'rgba(0, 0, 0,.55)',
};

Vue.config.productionTip = false
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Lazyload)
Vue.use(Icon)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Overlay)
Vue.use(SwipeCell)
Vue.use(Uploader)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Area)
Vue.use(ActionSheet)
Vue.use(Loading)
Vue.use(List)
Vue.use(Cell)
Vue.use(Skeleton)
Vue.use(VueSweetalert2,options)

router.afterEach((to,from,next)=>{
	window.scrollTo(0,0)
})
router.beforeEach((to,from,next)=>{
	if(to.meta.requierAuth){
		if(GetCookie('token')){
			Axios.defaults.headers.common['Authorization']=GetCookie('token')
			Axios.get('/common/check/token')
			.then(
				response=>{
					if(response.data.code==200&&response.data.status=="success"){
						next()
					}
				}
			).catch(
				error=>{
					DelCookie('token')
					DelCookie('phone')
					DelCookie('real_auth')
					DelCookie('pn')
					Vue.prototype.$swal({
						text:'未登录或登录超时 请重新登录',
						showConfirmButton:false,
						width:'6rem',
						padding:'0.5rem',
						timer:800,
						imageWidth:50,
						imageHeight:50,
						imageUrl:notifyIcon,
						timerProgressBar: true
					})
					setTimeout(()=>{
						location.href='/login'
					},800)
				}
			)
		}else{
			Vue.prototype.$swal({
				text:'未登录或登录超时 请重新登录',
				showConfirmButton:false,
				width:'6rem',
				padding:'0.5rem',
				timer:800,
				imageWidth:50,
				imageHeight:50,
				imageUrl:notifyIcon,
				timerProgressBar: true
			})
			setTimeout(()=>{
				location.href='/login'
			},800)
		}
	}else{
		next()
	}
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
